<div class="activity-page">
  <div class="activity-header">
    <div class="activity-header__icon">
      <i class="fas fa-stream"></i>
    </div>
    <div>
      <h2 class="activity-header__title">Automation Activity</h2>
      <p class="activity-header__subtitle">
        Live activity from the NextGen automation bot and the backend processing pipeline.
      </p>
    </div>
    <button type="button" class="activity-header__ops-btn" (click)="openLiveOperations()">
      <i class="fas fa-satellite-dish"></i> Live Operations
    </button>

    <div class="activity-header__live">
      <span class="live-dot" [class.live-dot--refreshing]="loading"></span>
      Live
    </div>
  </div>

  <div class="activity-filters">
    <div class="activity-filters__search">
      <i class="fas fa-search"></i>
      <input
        type="text"
        placeholder="Search by patient name…"
        [(ngModel)]="patientNameFilter"
        (ngModelChange)="onSearchInput()"
      />
    </div>

    <select class="activity-filters__select" [(ngModel)]="levelFilter" (ngModelChange)="onFilterChange()">
      <option value="">All levels</option>
      <option value="info">Info</option>
      <option value="success">Success</option>
      <option value="warn">Warning</option>
      <option value="error">Error</option>
    </select>

    <input
      type="text"
      class="activity-filters__input"
      placeholder="Practice ID"
      [(ngModel)]="practiceFilter"
      (change)="onFilterChange()"
    />

    <button type="button" class="activity-filters__clear" *ngIf="hasActiveFilters" (click)="clearFilters()">
      <i class="fas fa-times"></i> Clear filters
    </button>
  </div>

  <div class="activity-table__wrapper">
    <table class="activity-table" *ngIf="rows.length || loading">
      <thead>
        <tr>
          <th class="col-time">Time</th>
          <th class="col-patient">Patient</th>
          <th class="col-event">Event</th>
          <th class="col-message">Message</th>
          <th class="col-level">Level</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows" class="activity-row" [ngClass]="'activity-row--' + row.level">
          <td class="col-time">{{ formatTime(row.created_at) }}</td>
          <td class="col-patient">
            <ng-container *ngIf="row.patient; else noPatient">
              <button
                type="button"
                class="patient-avatar"
                [style.background]="patientAvatarColor(row)"
                [ngbTooltip]="patientLabel(row) + (row.patient.med_rec_nbr ? ' · MRN ' + row.patient.med_rec_nbr : '')"
                placement="top"
                (click)="openPatientActivity(row)"
              >
                {{ patientInitials(row) }}
              </button>
            </ng-container>
            <ng-template #noPatient><span class="text-muted">—</span></ng-template>
          </td>
          <td class="col-event">
            <div class="event-cell">
              <i class="fas event-cell__icon" [ngClass]="categoryIcon(row.category)"></i>
              <div>
                <div class="event-cell__category">{{ categoryLabel(row.category) }}</div>
                <div class="event-cell__step">{{ row.step }}</div>
              </div>
            </div>
          </td>
          <td class="col-message">{{ row.message }}</td>
          <td class="col-level">
            <span class="level-pill" [ngClass]="'level-pill--' + row.level">{{ row.level }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="activity-empty" *ngIf="!rows.length && !loading && !initialLoad">
      <i class="fas fa-inbox"></i>
      <p>No activity logs match your filters.</p>
      <button type="button" class="activity-filters__clear" *ngIf="hasActiveFilters" (click)="clearFilters()">
        Clear filters
      </button>
    </div>

    <div class="activity-empty" *ngIf="initialLoad && loading">
      <i class="fas fa-circle-notch fa-spin"></i>
      <p>Loading activity…</p>
    </div>
  </div>

  <div class="activity-pagination" *ngIf="rows.length">
    <span class="activity-pagination__total">{{ total }} total entries</span>
    <div class="activity-pagination__controls">
      <button type="button" [disabled]="!previousPage" (click)="goToPage(previousPage)">
        <i class="fas fa-chevron-left"></i> Prev
      </button>
      <span class="activity-pagination__page">Page {{ currentPage }}</span>
      <button type="button" [disabled]="!nextPage" (click)="goToPage(nextPage)">
        Next <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>
</div>
